module.exports = __webpack_public_path__ + "img/h5.95960249.png";